<div class="flex-column f-1-0 gap-4">

	<div class="flex-column f-1-0">
		<!--Page loader-->
		<div class="flex-row justify-content-center f-1-0" *ngIf="getRulesDataInProcess">
			<loader height="100" width="100" style="opacity: 0.8;"></loader>
		</div>
		<!--Create first rule-->
		<div class="flex-row justify-content-center f-1-0" *ngIf="!getRulesDataInProcess && !createNewRulesInProcess && !rules?.length">
			<div class="flex-column align-items-center f-1-0 text-center gap-3 px-4 py-5 bg-light" style="align-self: flex-start;">
				<h1 style="opacity:0.4; font-size: 36px;">Create your first rule</h1>
				<span>Create rules by selecting conditions for when the rule should be triggered, and actions that should be taken when the rule is triggered.<br/> Rules can be turned off.</span>
				<br/>
				<btn-c id="newRule" class="popup-action-btn"
					   [isDisabled]="!rules"
					   endIcon="far fa-plus"
					   (action)="createNewRule();">
					Create New Rule
				</btn-c>
			</div>
		</div>

		<div class="flex-column gap-1 f-1-0 animated fadeIn" *ngIf="!getRulesDataInProcess && !createNewRulesInProcess && rules?.length">
			<!--rules-->
			<trustifi-table-c
				class="trustifi-table" style="flex: 1 0; z-index: 5; background: white;"
				[list]="rules"
				[headers]="[
					{text: 'Priority', width: '80px'},
					{text: 'Name', width: '15%' },
					{text: 'Active', width: '140px' },
					{text: 'Condition', width: '30%'},
					{text: 'Action to perform', width: '20%'},
					{text: 'Last Modified', width: '135px'},
				]"
				[cellsPrototype]="[
					{textKey: 'priorityDisplay'},
					{html: 'nameCell'},
					{html: 'statusCell', overflowOutside: true},
					{html: 'conditionsCell'},
					{html: 'actionCell'},
					{textKey: 'created', textType: 'dateAndTime'},

				]"
				[cellActions]="{
					enable: true,
					selectItemActionCb:	selectRuleAction,
					initActionsFunction: showRuleActions,
				}"
				[bulkActions]="{
					enable: true,
					selectBulkActionCb:	selectMultipleRulesAction,
					initBulkActionsFunction: showMultipleRulesActions,
				}"
				(searchFunction)="searchRule($event.searchTerm, $event.activeFilters)"
				[options]="{
					itemsNameSingular: 'rule',
					itemUniqueIdentifier: '_id',
					isEllipsis: false
				}"
				(onDragAndDrop)="!$event.isDroppedOnNextItem && updateRulePriority($event.draggedItem, $event.draggedOntopItem)"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<!--name cells-->
					<span *ngIf="cellId === 'nameCell'">
						<span>{{item.name}}</span>
					</span>
					<!--active cells-->
					<div *ngIf="cellId === 'statusCell'">
						<toggle-switch-c [(model)]="item.enabled"
										 textTrue="Active" textFalse="Inactive"
										 (onChange)="updateRuleState([item], item.enabled)">
						</toggle-switch-c>
					</div>
					<!--condition details cells-->
					<span class="flex-column gap-2" *ngIf="cellId === 'conditionsCell'">
						<div class="flex-row w100 gap-2" *ngFor="let conditionArr of item.conditions; let first = first;">
							<span class="fw-bold flex-shrink-0" style="flex-basis: 65px; color: #486db5;">{{first ? 'IF' : 'AND'}}</span>
							<div class="flex-column gap-1" style="word-break: break-word;">
								<ng-container *ngFor="let condition of conditionArr; let last = last;">
									<span [innerHTML]="condition.text"></span>
									<span class="fw-bold opacity-75" style="color: #486db5; margin: -4px 0;" *ngIf="!last">OR</span>
								</ng-container>
							</div>
						</div>
						<ng-container *ngIf="item.exceptions?.length">
						<div class="flex-row w100 gap-1" *ngFor="let exceptionArr of item.exceptions; let first = first;">
							<span class="fw-bold flex-shrink-0" style="flex-basis: 65px; color: #906b24;">{{first ? 'EXCEPT IF' : 'AND'}}</span>
							<div class="flex-column gap-1" style="word-break: break-word;">
								<ng-container *ngFor="let exception of exceptionArr; let last = last;">
									<span [innerHTML]="exception.text"></span>
									<span class="fw-bold opacity-75" style="color: #486db5; margin: -4px 0;" *ngIf="!last">OR</span>
								</ng-container>
							</div>
						</div>
						</ng-container>
					</span>
					<!--action details cells-->
					<div class="flex-column gap-1" style="font-size: 12px;" *ngIf="cellId === 'actionCell'">
						<span [innerHTML]="item.resultShow.join('<br/>')"></span>
					</div>
					<!--usage cells-->
					<span *ngIf="cellId === 'usageCell'">
						<div class="flxRow-center app-dropdown" style="padding: 2px min(1vw, 15px); height: 30px; cursor: pointer; margin-left: 3px; align-items: center;"
							 (click)="showRulesUsage(item); $event.stopPropagation();" tooltip="Usage data">
							<i class="fas hvr-opacity fa-chart-pie"
							   style="font-size: 1.4rem; background-image: conic-gradient(green 0deg 90deg, purple 90deg 135deg, blue 162deg 365deg); color: transparent; background-clip: text; -webkit-background-clip: text;"></i>
						</div>
					</span>
				</ng-template>

				<div tableButtons>
					<btn-c id="newRule"
						   [isDisabled]="!rules"
						   endIcon="far fa-plus"
						   (action)="createNewRule();">
						Create New Rule
					</btn-c>
				</div>
			</trustifi-table-c>
		</div>

		<div class="flex-column w-100 gap-2 py-2 pe-2" *ngIf="createNewRulesInProcess">
			<b>{{!!newRule._id ? 'Edit Rule' : 'Create New Rule'}}</b>

			<!--Rule name-->
			<div class="flex-row w-100 gap-3 align-items-center my-3">
				<span class="flex-shrink-0" style="flex-basis: 100px; text-align: right;">Rule name:</span>
				<div class="f-1-0 flex-row gap-4">
					<input id="outboundRuleName" type="text" placeholder="Rule name" style="width: 235px;"
						   autocomplete="off"
						   [appAutoFocus]="true"
						   [ngClass]="(invalidRuleName) && 'validation-error'"
						   [(ngModel)]="newRule.name"
						   (ngModelChange)="isNameChanged();"/>
				</div>
			</div>

			<div class="py-2 px-3 fw-500" style="font-size: 14px; background: linear-gradient(90deg, #f7f7f7, #ffffff);">
				<span class="text-primary">Conditions</span>
			</div>

			<!--Rule conditions-->
			<div class="flex-column gap-2" style="z-index: 20;">
				<div class="flex-row w-100 gap-3" *ngFor="let condition of newRule.conditions; let index = index; let first = first;"
					 [style.z-index]="80 - index">
					<span class="fw-bold flex-shrink-0" style="flex-basis: 100px; text-align: right; font-size: 17px; color: #486db5; padding-top: 20px;">
						{{first ? 'IF' : 'AND'}}
					</span>
					<div class="flex-row gap-2 f-1-0 px-4 flex-wrap align-items-end" style="border: dashed 1px #ccc; max-width: 1200px; padding-top: 15px; padding-bottom: 15px;">
						<new-rule-condition-compromised style="display: contents;"
														[conditionIndex]="index" [condition]="condition"
														[newRule]="newRule"
														[users]="users">
						</new-rule-condition-compromised>
						<div class="flex-shrink-0" style="margin: 8px -10px -15px auto;"
							 [tooltip]="condition[0].type === dic.CONSTANTS.accountCompromisedRule.types.target_users.name ? '<b>Incident Target Users</b> is not allowed within OR condition' : null">
							<a class="blue-link fw-bold flex-row align-items-center gap-1 flex-shrink-0" style="color: #486db5; padding: 8px 15px;"
							   [ngClass]="{'disabled' : condition[0].type === dic.CONSTANTS.accountCompromisedRule.types.target_users.name}"
							   (click)="condition[0].type !== dic.CONSTANTS.accountCompromisedRule.types.target_users.name && addORtoCondition(condition, false)">
								<i class="far fa-plus" style="font-size: 9px;"></i>
								<span>Add 'OR' to condition</span>
							</a>
						</div>
					</div>
				</div>
				<div class="flex-row w-100 gap-3 mt-2" style="z-index: 2;">
					<div class="flex-shrink-0" style="flex-basis: 100px;"></div><!--padder-->
					<div class="flex-row gap-2">
						<btn-c id="addRuleConditionBtn" class="rules-add-condition-btn" style="width: 130px;"
							   variant="outlined-dashed" endIcon="far fa-plus"
							   (action)="addConditionToRule()">
							Add Condition
						</btn-c>
						<btn-c id="addRuleExceptionBtn" class="rules-add-condition-btn" style="width: 130px;"
							   *ngIf="!newRule.exceptions?.length"
							   variant="outlined-dashed" endIcon="far fa-plus"
							   color="#906b24"
							   (action)="addExceptionToRule()">
							Add Exception
						</btn-c>
					</div>
				</div>
			</div>

			<!--Rule exceptions-->
			<div class="flex-column gap-2 mt-3" style="z-index: 15;" *ngIf="newRule.exceptions?.length">
				<div class="flex-row w-100 gap-3" *ngFor="let condition of newRule.exceptions; let index = index; let first = first;"
					 [style.z-index]="80 - index">
					<span class="fw-bold flex-shrink-0" style="flex-basis: 100px; text-align: right; font-size: 17px; color: #906b24; padding-top: 20px;">
						{{first ? 'EXCEPT IF' : 'AND'}}
					</span>
					<div class="flex-row gap-2 f-1-0 px-4 flex-wrap align-items-end" style="border: dashed 1px #ccc; max-width: 1200px; padding-top: 15px; padding-bottom: 15px;">
						<new-rule-condition-compromised style="display: contents;"
														[conditionIndex]="index" [condition]="condition"
														[newRule]="newRule"
														[users]="users">
						</new-rule-condition-compromised>
						<div class="flex-shrink-0" style="margin: 8px -10px -15px auto;"
							 [tooltip]="condition[0].type === dic.CONSTANTS.accountCompromisedRule.types.target_users.name ? '<b>Incident Target Users</b> is not allowed within OR condition' : null">
							<a class="blue-link fw-bold flex-row align-items-center gap-1" style="color: #486db5; padding: 8px 15px;"
							   [ngClass]="{'disabled' : condition[0].type === dic.CONSTANTS.accountCompromisedRule.types.target_users.name}"
							   (click)="condition[0].type !== dic.CONSTANTS.accountCompromisedRule.types.target_users.name && addORtoCondition(condition, true)">
								<i class="far fa-plus" style="font-size: 9px;"></i>
								<span>Add 'OR' to condition</span>
							</a>
						</div>

					</div>
				</div>
				<div class="flex-row w-100 gap-3 mt-2" style="z-index: 2;">
					<div class="flex-shrink-0" style="flex-basis: 100px;"></div><!--padder-->
					<div class="flex-row gap-2">
						<btn-c id="addRuleExceptionBtn" class="rules-add-condition-btn" style="width: 130px;"
							   variant="outlined-dashed" endIcon="far fa-plus"
							   color="#906b24"
							   (action)="addExceptionToRule()">
							Add Exception
						</btn-c>
					</div>
				</div>
			</div>

			<div class="flex-row w-100 gap-3">
				<div class="flex-shrink-0" style="flex-basis: 100px;"></div><!--padder-->
				<hr class="f-1-0 mb-0"/>
			</div>

			<div class="d-flex py-2 mt-3 mb-2 px-3 fw-500" style="font-size: 14px; background: linear-gradient(90deg, #f7f7f7, #ffffff);">
				<span class="text-primary">Actions</span>
			</div>

			<!--results-->
			<div class="flex-column gap-2">
				<div class="flex-row w-100 gap-3">
					<span class="fw-bold flex-shrink-0" style="flex-basis: 100px; text-align: right; font-size: 17px; color: #486db5; padding-top: 20px;">
						THEN
					</span>
					<!--main result-->
					<div class="f-1-0 flex-row gap-2 px-4 align-items-center" style="border: dashed 1px #ccc; max-width: 1200px; padding-top: 10px; padding-bottom: 10px;">
						<app-dropdown-c style="width: 235px; --dropdown-menu-width: 800px;" id="{{'AccountCompromisedRulesDropdownResult'}}"
										(click)="clearSearchResults();"
										[showTitle]="true" [error]="invalidResults"
										text="{{newRule.resultShow.join(', ') || 'Choose'}}">
							<ul style="overflow: auto; min-height: 110px;">
								<li class="static-item" style="min-height: 0; z-index: 5;" (click)="$event.stopPropagation()">
									<div class="search-box flxRow" style="position: relative; max-width: 300px;">
										<input type="search" class="w-100"
											   [(ngModel)]="searchResultsText"
											   maxlength="{{dic.CONSTANTS.maxCharsInSearch}}"
											   (keyup)="searchResults(searchResultsText);"
											   placeholder="Search action">
										<a class="closeRed animated fadeIn"
										   id="clearSearchResults"
										   (click)="clearSearchResults();"
										   *ngIf="searchResultsText"
										   style="font-size: 16px; color: #cccccc; position: absolute; right: 15px; top: calc(50% + 1px); transform: translateY(-50%);">
											<i class="zmdi zmdi-close"></i>
										</a>
									</div>
								</li>
								<div class="flex-row flex-wrap overflow-auto" style="max-height: 33vh;">
									<li *ngFor="let result of dic.CONSTANTS.accountCompromisedRule.defaultResult | keyvalue: gs.returnZero"
										class="flex-column w-50" style="gap: 3px;"
										(click)="newRule.result[result.key].enabled = !newRule.result[result.key].enabled; isResultChanged(result);$event.stopPropagation();"
										[hidden]="result?.value?.hideInResultList || newRule.result[result.key].hide">
										<checkbox (click)="$event.preventDefault();"
												  [(model)]="newRule.result[result.key].enabled">
											<div class="flex-column gap-1 position-relative" style="font-size: 13px;">
												<span class="fw-500" style="font-size: 14px;">{{result.value.label}}</span>
												<i style="color: #505050; font-size: 12px;">{{dic.CONSTANTS.accountCompromisedRule.defaultResult[result.key].explanation}}</i>
											</div>
										</checkbox>
									</li>
									<li *ngIf="searchResultNotFound" class="d-flex centralize py-3" (click)="$event.stopPropagation()">
										No items found
									</li>
								</div>
							</ul>
						</app-dropdown-c>
					</div>
				</div>
			</div>

			<br/>

			<div class="flex-row gap-2">
				<btn-c style="width: 120px;" id="outboundRulesCancelNewRule"
					   endIcon="far fa-ban" variant="outlined"
					   (action)="cancelNewRule();">
					Cancel
				</btn-c>
				<btn-c style="width: 120px;" id="outboundRulesPrepareRule"
					   [isDisabled]="prepareRuleInProcess"
					   endIcon="{{!!newRule._id ? 'far fa-check' : 'far fa-plus'}}"
					   (action)="prepareRule();">
					{{!!newRule._id ? 'Update Rule' : 'Add Rule'}}
				</btn-c>
			</div>
		</div>
	</div>

	<!--Rule Usage popup-->
	<popup-c *ngIf="ruleUsagePopup?.show"
			 head="Account takeover Rule Usage Data"
			 subTitle="<b>Rule name:</b> {{ruleUsagePopup.ruleObj.name}}"
			 (closeCb)="ruleUsagePopup = null"
			 width="min(calc(100vw - 5vh*2),1200px)">
		<div class="flex-column f-1-0 gap-4" [ngStyle]="{'overflow' : ruleUsagePopup.viewType === viewTypes.list ? 'auto' : ''}">
			<div class="flex-row gap-4 align-items-center">
				<div class="period-buttons-group bs-enabled flxRow hSpace1">
					<btn-c
						variant="{{ruleUsagePopup.usagePeriod.value !== periodObj.value ? 'outlined' : ''}}"
						*ngFor="let periodObj of trendsPeriod"
						[isDisabled]="getRuleUsageInProcess"
						(action)="changePeriod(periodObj);">
						{{periodObj.display}}
					</btn-c>
				</div>
				<div class="vertical-separator opacity-25"></div>
				<!--list/graph selection-->
				<div class="period-buttons-group align-self-center flex-row gap-2 animated fadeIn">
					<button class="period-button bs-btn bs-btn-light text-capitalize"
							*ngFor="let type of viewTypes | keyvalue: gs.returnZero"
							[ngClass]="{'chosen' : type.value === ruleUsagePopup.viewType}"
							(click)="changeViewType(type.value);"
							tooltip="{{type.value}}">
						<i style="height: 20px; width: 20px; font-size: 1.1rem; margin-left: 2px;"
						   [ngClass]="type.value === viewTypes.list ? 'far fa-list' : 'fas fa-chart-pie'"></i>
					</button>
				</div>

				<div *ngIf="getRuleUsageInProcess" class="loading-spinner" style="width: 20px; height: 20px; border-width: 3px;"></div>
			</div>


			<div class="flex-column f-1-0 animated fadeIn" style="overflow: auto;"
				 *ngIf="ruleUsagePopup?.viewType === viewTypes?.list">
				<trustifi-table-c
					class="trustifi-table" style="flex: 1 0; z-index: 5;"
					[list]="ruleUsagePopup.emails"
					[headers]="[
							{text:'Subject', sortKey:'subject'},
							{text:'From', sortKey:'sender'},
							{text:'Mailbox', sortKey:'mailbox_email'},
							{text:'Sent', sortKey:'created'},
							{text:'Message ID'},
						]"
					[cellsPrototype]="[
							{textKey: 'subject'},
							{textKey: 'sender'},
							{textKey: 'mailbox_email'},
							{textKey: 'created', textType: 'dateAndTime'},
							{html: 'messageIdCell'},
						]"
					[scopeInstances]="[{copyEmailIdToClipboard: copyEmailIdToClipboard}]"
					(searchFunction)="searchRuleEmail($event.searchTerm)"
					[options]="{
							exportToCsvFunction: exportRuleEmailsToCsv,
							defaultSortKey: '-created',
							itemsNameSingular: 'email',
						}"
				>
					<ng-template #customCells let-item let-cellId="cellId">
						<!--action cells-->
						<div *ngIf="cellId === 'messageIdCell'">
							<div class="flex-row align-items-center cursor-pointer gap-1 copy-link"
								 (click)="copyEmailIdToClipboard(item)">
								<i class="far fa-copy" style="cursor: pointer;"></i>
								<span style="font-size: 11px;">Copy ID</span>
							</div>
						</div>
					</ng-template>
					<!---->

					<div tableButtons>
						<span style="font-size: 0.95rem;">List of the emails detected by this rule in the {{ruleUsagePopup.usagePeriod.display | lowercase}}</span>
					</div>
				</trustifi-table-c>
			</div>

			<div class="flex-column f-1-0 position-relative animated fadeIn bg-light overflow-auto" *ngIf="ruleUsagePopup.viewType === viewTypes.chart">
				<div class="bs-container f-1-0 flex-column bg-light border overflow-auto">
					<div class="bs-row h-100 f-1-0 overflow-auto">
						<!--Emails-->
						<div class="bs-col-6 p-2 h-100">
							<div class="trends-data-card flex-column gap-1 p-3 w-100">
								<div class="flex-column align-items-start gap-1">
									<h6 class="m-0 fw-bold">Total amount of emails detected by this rule</h6>
								</div>
								<div class="flex-column centralize f-1-0 p-3">
									<apx-chart class="f-1-0 animated fadeIn align-self-stretch" style="z-index: 40;"
											   *ngIf="ruleUsagePopup?.emails?.length"
											   #emailsDetectedChart
											   [options]="{display: false}"
											   [series]="emailDetectedByRuleChartOptions.series"
											   [chart]="emailDetectedByRuleChartOptions.chart"
											   [plotOptions]="emailDetectedByRuleChartOptions.plotOptions"
											   [colors]="emailDetectedByRuleChartOptions.colors"
											   [dataLabels]="emailDetectedByRuleChartOptions.dataLabels"
											   [stroke]="emailDetectedByRuleChartOptions.stroke"
											   [yaxis]="emailDetectedByRuleChartOptions.yaxis"
											   [fill]="emailDetectedByRuleChartOptions.fill"
											   [tooltip]="emailDetectedByRuleChartOptions.tooltip"
											   [xaxis]="emailDetectedByRuleChartOptions.xaxis"></apx-chart>
									<!--loader / placeholder-->
									<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!ruleUsagePopup?.emails?.length">
										<div class="flex-column text-center centralize f-1-0">
											<span class="fw-500 opacity-75" *ngIf="!getRuleUsageInProcess">No data for selected time period</span>
											<loader class="opacity-75 align-self-center" *ngIf="getRuleUsageInProcess" height="100" width="100"></loader>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="bs-col-6 p-2 flex-column gap-2 h-100">
							<!--Senders-->
							<div class="trends-data-card flex-column gap-1 p-3 w-100 f-1-0">
								<div class="flex-column align-items-start gap-1">
									<h6 class="m-0 fw-bold">Results sorted by top senders</h6>
								</div>
								<div class="flex-column centralize f-1-0 p-3">
									<apx-chart class="f-1-0 animated fadeIn align-self-stretch"
											   *ngIf="ruleUsagePopup?.emails?.length"
											   #topSendersChart
											   [series]="senderGraphOptions.series"
											   [chart]="senderGraphOptions.chart"
											   [dataLabels]="senderGraphOptions.dataLabels"
											   [colors]="senderGraphOptions.colors"
											   [plotOptions]="senderGraphOptions.plotOptions"
											   [xaxis]="senderGraphOptions.xaxis"
											   [yaxis]="senderGraphOptions.yaxis"></apx-chart>
									<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!ruleUsagePopup?.emails?.length">
										<div class="flex-column text-center centralize f-1-0">
											<span class="fw-500 opacity-75" *ngIf="!getRuleUsageInProcess">No data for selected time period</span>
											<loader class="opacity-75 align-self-center" *ngIf="getRuleUsageInProcess" height="100" width="100"></loader>
										</div>
									</div>
								</div>
							</div>

							<!--Recipients-->
							<div class="trends-data-card flex-column gap-1 p-3 w-100 f-1-0">
								<div class="flex-column align-items-start gap-1">
									<h6 class="m-0 fw-bold">Results sorted by top recipient mailboxes</h6>
								</div>
								<div class="flex-column centralize f-1-0 p-3">
									<apx-chart class="f-1-0 animated fadeIn align-self-stretch"
											   *ngIf="ruleUsagePopup?.emails?.length"
											   #topRecipientMailboxesChart
											   [series]="recipientGraphOptions.series"
											   [chart]="recipientGraphOptions.chart"
											   [dataLabels]="recipientGraphOptions.dataLabels"
											   [colors]="recipientGraphOptions.colors"
											   [plotOptions]="recipientGraphOptions.plotOptions"
											   [xaxis]="recipientGraphOptions.xaxis"
											   [yaxis]="recipientGraphOptions.yaxis"></apx-chart>
									<div class="flex-column p-3 animated fadeIn h-100 w-100" *ngIf="!ruleUsagePopup?.emails?.length">
										<div class="flex-column text-center centralize f-1-0">
											<span class="fw-500 opacity-75" *ngIf="!getRuleUsageInProcess">No data for selected time period</span>
											<loader class="opacity-75 align-self-center" *ngIf="getRuleUsageInProcess" height="100" width="100"></loader>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</popup-c>
</div>

